module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Many thanks to Jim Frenkel, Dominick Abel, Peter Calandra, Sgt. David Graves, Captain Randy Lynch, Walt Boyne, Phil Motoike, J. L. Brown, Tom Howley, Joe Kelleher, Rod Webber, Doug Bolick, Larry Stone, Sgt. Luke Hartmetz, Brian Malone, “Snake” Jackson, Dmitry and Oleg Gurtovoy, Clancy Miller, Jim Cook, John Daniels, Bill Kellan, Jack Shane, Buzz Summers, Gil Gillis, James Beam, Sgt. Tony Pluger, Gene Smith, Chip Bruynell, Mark Conley, Bob Messia, Seth Lerner, Ed Chapman, George Ebersole, Ron Elkin, Steve Minar, Richard Kennedy, Sr., Robert Buonfiglio, and especially, Doug Newman. Very special thanks to my wife, Doreen.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725840fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 75
// module chunks = 0